import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "./common/Card";
import Grid from "@material-ui/core/Grid";
import Typography from "./common/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import crioLogo from "../../src/assets/crio-logo-white.svg";
import axios from "axios";
import Loader from "./common/Loader/Loader";
import milestone1 from "../../src/assets/milestone1.png";
import start from "../../src/assets/start.png";
import qmoney from "../../src/assets/qmoney.png";
import qeatsperf from "../../src/assets/qeatsperf.gif";
import mil3biryani from "../../src/assets/mil3biryani.png";
import mil3idly from "../../src/assets/mil3idly.png";
import mil3south from "../../src/assets/mil3south.png";

import mil51item from "../../src/assets/mil51item.png";
import mil52item from "../../src/assets/mil52item.png";
import mil53item from "../../src/assets/mil53item.png";
import mil5order from "../../src/assets/mil5order.png";
import mil5cart from "../../src/assets/mil5cart.png";

import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

const styles = theme => ({
  top: {
    borderBottom: "1px solid" + theme.palette.primary.primaryBorder,
    padding: "0px 25px 60px 55px"
  },
  middle: {
    margin: "45px 55px"
  },
  subtitle: {
    display: "flex",
    alignItems: "center"
  },
  socialIcon: {
    color: theme.palette.primary.primary,
    fontSize: "32px",
    marginLeft: "20px"
  },
  arrowIcon: {
    color: theme.palette.primary.primary,
    marginLeft: "5px",
    cursor: "pointer"
  },
  programs: {
    margin: "45px 0px",
    color: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center"
  },

  programRow: { padding: "60px 0px 0px 0px" },
  MERow: {
    margin: "55px 0px 0px 0px"
  },
  programPill: {
    display: "inline-flex",
    alignItems: "center",
    background: "#3f3f3f",
    width: "fit-content",
    padding: "16px",
    borderRadius: "8px",
    margin: "10px 0px"
  }
});
class MEDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { meDetail: {}, data: "", me: "", isLoading: true };
  }
  componentDidMount() {
    let currentME = this.props.match.params.meid;
    this.setState({ me: currentME }, () => {
      // // if (this.props.history.location.aboutProps) {
      // //   if (this.state.me === "ME_JAVA_WARMUP_V2")
      // //     this.props.history.location.aboutProps.getTitle(" - QTravel");
      // //   else if (this.state.me === "ME_QEATS") {
      // //     this.props.history.location.aboutProps.getTitle(" - QEats");
      // //   } else if (this.state.me === "ME_STOCK_ANALYZER") {
      // //     this.props.history.location.aboutProps.getTitle(
      // //       " - QMoney Stock Analyzer"
      // //     );
      // //   }
      // }
    });
    this.container.scrollTop = 0;
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container ref={el => (this.container = el)}>
        <Grid row lg={2} md={1} xs={1}></Grid>
        <Grid row lg={7} md={10} xs={10}>
          <Card>
            {this.state.me === "ME_JAVA_WARMUP_V2" ? (
              <>
                <Link
                  to={{
                    pathname: "/crio-pdp-2019-" + process.env.REACT_APP_GITHUB
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginBottom: "20px"
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fas", "arrow-left"]}
                      style={{
                        fontSize: "1.5em",
                        margin: "0px 10px 0px 55px",
                        cursor: "pointer",
                        color: "#999"
                      }}
                    ></FontAwesomeIcon>
                    <Typography cursor="pointer" color="#999">
                      Back
                    </Typography>
                  </div>
                </Link>
                <div className={classes.top}>
                  <Grid container>
                    <Grid item xs={7}>
                      <div style={{ margin: "0px 0px 10px 0px" }}>
                        <Typography fontSize="46px"> QTravel</Typography>
                      </div>
                      <Typography fontSize="34px" color="rgba(0,0,0,0.6)">
                        An app used by travelers to get weather forecasts ahead
                        of their trips.
                      </Typography>
                    </Grid>
                    <Grid item xs={5} style={{ textAlign: "right" }}>
                      {/* <div className={classes.programPill}>
                        <img
                          alt="Crio.Do"
                          src={crioLogo}
                          style={{ marginRight: "10px" }}
                        ></img>
                        <Typography type="heading4" color="rgba(255,255,255,1)">
                          Product Development Program
                        </Typography>
                      </div>
                      <div style={{ float: "right" }}>
                        <Typography type="body5" color="rgba(0,0,0,1)">
                          31 Oct 2019 - 29 Feb 2020
                        </Typography>
                      </div> */}
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.middle}>
                  <Typography color="rgba(0,0,0,1)" fontSize="20px">
                    QTravel Modules
                  </Typography>

                  <ul className="timeline">
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Foundational Linux concepts
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Essential Linux commands focused on
                                        directory navigation, output parsing,
                                        processes tracking, and memory usage
                                        analysis.
                                      </li>
                                      <li>
                                        Linux networking commands related to IP
                                        addresses, ports, and routing tables.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography type="body5" color="#000">
                                      Essential Linux Commands
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Fetch weather data from an external source to
                              forecast rain in a given time period
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Fetching weather data by querying REST
                                        API endpoints of a third-party service.
                                      </li>
                                      <li>
                                        Using weather data to forecast rain in a
                                        given time interval.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      JSON, REST API, cURL
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Refactor and use Java interfaces to add support
                              for an additional weather source
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Refactoring code using Java Interfaces
                                        to add an additional weather data
                                        source.
                                      </li>
                                      <li>
                                        Writing unit tests to ensure that code
                                        refactoring does not introduce
                                        regressions.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      Java Interfaces, Packages, Mockito, Unit
                                      Testing
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              MongoDB 101
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li> Foundational topics in MongoDB.</li>
                                      <li>
                                        CRUD operations on MongoDB collections.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      MongoDB
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            ) : this.state.me === "ME_QEATS" ? (
              <>
                {" "}
                <Link
                  to={{
                    pathname: "/crio-pdp-2019-" + process.env.REACT_APP_GITHUB
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginBottom: "20px"
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fas", "arrow-left"]}
                      style={{
                        fontSize: "1.5em",
                        margin: "0px 10px 0px 55px",
                        cursor: "pointer",
                        color: "#999"
                      }}
                    ></FontAwesomeIcon>
                    <Typography cursor="pointer" color="#999">
                      Back
                    </Typography>
                  </div>
                </Link>
                <div className={classes.top}>
                  <Grid container>
                    <Grid item xs={7}>
                      <div style={{ margin: "0px 0px 10px 0px" }}>
                        <Typography fontSize="48px"> QEats</Typography>
                      </div>
                      <Typography fontSize="34px" color="rgba(0,0,0,0.6)">
                        A scalable distributed backend for a food-ordering app.
                      </Typography>
                    </Grid>
                    <Grid item xs={5} style={{ textAlign: "center" }}>
                      <img width="100px" src={start}></img>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.middle}>
                  <div style={{ margin: "0px 0px 20px 0px" }}>
                    <Typography color="rgba(0,0,0,1)" fontSize="20px">
                      QEats Modules
                    </Typography>
                  </div>

                  <ul className="timeline">
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Retrieve restaurant data for a given user location
                            </Typography>
                            <div style={{ padding: "40px 0px" }}>
                              <Zoom>
                                <img src={milestone1} width="200px"></img>
                              </Zoom>
                            </div>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Implement GET /api/v1/restaurants and
                                        the corresponding request handler and
                                        response methods.
                                      </li>
                                      <li>
                                        Use Mockito to enable the development of
                                        the relevant MVCS layers independently.
                                      </li>
                                      <li>
                                        Retrieve a list of restaurants from
                                        MongoDB based on a user location.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      Spring Boot, Spring Data, REST API,
                                      Jackson, Mockito, JUnit, MongoDB
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Resolve production issues using Scientific
                              Debugging
                            </Typography>

                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Analyze log files to additional details
                                        about a production issue.
                                      </li>
                                      <li>
                                        Use IDE features (breakpoints) and
                                        assert statements to identify the root
                                        cause.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      Scientific debugging
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Replicate performance issues and solve them using
                              caching strategies
                            </Typography>
                            <div style={{ padding: "40px 0px" }}>
                              <Zoom>
                                <img src={qeatsperf} width="400px"></img>
                              </Zoom>
                            </div>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Employ JMeter for load testing to expose
                                        performance issues.
                                      </li>
                                      <li>
                                        Identify DB queries contributing to
                                        degradation in performance.
                                      </li>
                                      <li>
                                        Use a Redis cache to alleviate read
                                        performance.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      Redis, JMeter
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Perform search operations using custom attributes
                            </Typography>
                            <div
                              class="multipleImage"
                              style={{ padding: "40px 0px" }}
                            >
                              <Zoom>
                                <img src={mil3idly} width="200px"></img>
                              </Zoom>
                              <Zoom>
                                <img src={mil3south} width="200px"></img>
                              </Zoom>
                              <Zoom>
                                <img src={mil3biryani} width="200px"></img>
                              </Zoom>
                            </div>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Use MongoDB queries to enable users to
                                        search for restaurants using attributes
                                        like name, cuisine, dish, and price.
                                      </li>
                                      <li>
                                        Use multithreading to increase the
                                        number of concurrent searches that can
                                        be performed.
                                      </li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      MongoDB Queries, Multithreading
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            ) : this.state.me === "ME_STOCK_ANALYZER" ? (
              <>
                {" "}
                <Link
                  to={{
                    pathname: "/crio-pdp-2019-" + process.env.REACT_APP_GITHUB
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginBottom: "20px"
                    }}
                  >
                    <FontAwesomeIcon
                      icon={["fas", "arrow-left"]}
                      style={{
                        fontSize: "1.5em",
                        margin: "0px 10px 0px 55px",
                        cursor: "pointer",
                        color: "#999"
                      }}
                    ></FontAwesomeIcon>
                    <Typography cursor="pointer" color="#999">
                      Back
                    </Typography>
                  </div>
                </Link>
                <div className={classes.top}>
                  <Grid container>
                    <Grid item xs={7}>
                      <div style={{ margin: "0px 0px 10px 0px" }}>
                        <Typography fontSize="46px">
                          QMoney Stock Analyzer
                        </Typography>
                      </div>
                      <Typography fontSize="34px" color="rgba(0,0,0,0.6)">
                        An app to analyze stock portfolios.
                      </Typography>
                    </Grid>
                    <Grid item xs={5} style={{ textAlign: "center" }}>
                      <Zoom>
                        <img width="300px" src={qmoney}></img>
                      </Zoom>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.middle}>
                  <Typography color="rgba(0,0,0,1)" fontSize="20px">
                    QMoney Stock Analyzer Modules
                  </Typography>
                  <ul className="timeline">
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Build an API service that returns stock closing
                              prices on a given date
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    <ol style={{ padding: "0px 0px 0px 15px" }}>
                                      <li>
                                        Accept a list of stock symbols in the
                                        request message.
                                      </li>
                                      <li>
                                        Query a third-party service for
                                        historical stock prices.
                                      </li>
                                      <li>Return a JSON-formatted response.</li>
                                    </ol>
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      REST APIs, JSON
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                    <div
                      style={{
                        borderBottom: "1px solid #d8d8d8",
                        margin: "30px 0px 30px 80px"
                      }}
                    ></div>
                    <li>
                      <div className={classes.MERow} class="meRow">
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography type="heading3" color="rgba(0,0,0,1)">
                              Refactor and add additional third-party services
                            </Typography>
                            <div style={{ marginTop: "16px" }}>
                              <Grid container>
                                <Grid item xs={12} md={12} lg={2}>
                                  <Typography
                                    type="body5"
                                    color="rgba(0,0,0,0.6)"
                                  >
                                    Scope of work:
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={12} lg={10}>
                                  <Typography type="body5" color="#000">
                                    Use Java interfaces and factory methods to
                                    add additional third-party stock quote
                                    services.
                                  </Typography>
                                </Grid>
                              </Grid>

                              <div style={{ marginTop: "25px" }}>
                                <Grid container>
                                  <Grid item xs={12} md={2}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,0.6)"
                                    >
                                      Skills Learned:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} md={10}>
                                    <Typography
                                      type="body5"
                                      color="rgba(0,0,0,1)"
                                    >
                                      Java Interfaces, Factory Pattern, Packages
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <center>
                <Typography color="#999999">No data available</Typography>
              </center>
            )}
          </Card>
        </Grid>
        <Grid row lg={2} md={1} xs={1}></Grid>
      </Grid>
    );
  }
}
export default withStyles(styles)(MEDetail);
